import React from 'react';
import { connect } from 'react-redux';
import { countSelectedInCategory } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { endpoints } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import { confirmTokensDeletion, refreshTokens, showSaveToken } from '../actions';
import DisableTokensAction from './DisableTokensAction';
import myTokens, {
  canCreateToken, canDeleteToken, canDisableToken, canReadToken,
} from '../helper';

const TokensActions = ({
  category,
  readStatus,
  allowRefresh,
  allowCreate,
  allowDocs,
  allowDelete,
  disableDelete,
  refresh,
  showDelete,
  allowDisable,
  newToken,
}) => (
  <>
    {allowCreate && (<CreateAction onClick={newToken} />)}
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
    {allowDisable && (<DisableTokensAction category={category} />)}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={disableDelete} />)}
    {allowDocs && (
    <RibbonMenu
      name="docs"
      icon="file code outline"
      message="actions.api"
      url={endpoints.DOCS}
      target="api"
    />
    )}
  </>
);

const mapStateToProps = ({
  auth: { role },
  tokens: { tokens },
}, { category }) => {
  const { readStatus } = tokens[category];
  const count = countSelectedInCategory(tokens, category);

  return ({
    allowRefresh: canReadToken(category, role),
    allowCreate: canCreateToken(category, role),
    allowDelete: canDeleteToken(category, role),
    allowDisable: canDisableToken(category, role),
    allowDocs: myTokens(category),
    disableDelete: readStatus === states.PENDING || count === 0,
    readStatus,
  });
};

const mapDispatchToProps = {
  refresh: refreshTokens,
  showDelete: confirmTokensDeletion,
  newToken: () => showSaveToken(null, null),
};

export default connect(mapStateToProps, mapDispatchToProps)(TokensActions);
